import { createI18nText } from '@hilma/netina2all';

const commonQText = createI18nText({
    he: {
        title: 'שאלות נפוצות',
        subtitle: <>מקווים שתמצאו כאן מענה לכל השאלות<br /> אם בכל זאת משהו לא מובן, מוזמנים ליצור איתנו קשר</>,
        contactUs: 'צור קשר',
        moreQ: 'יש לכם שאלה נוספת?',
    },
    en: {
        title: 'Common Questions',
        subtitle: <>We hope you find the answers to all your questions here<br />If you still have any questions, feel free to contact us</>,
        contactUs: 'Contact Us',
        moreQ: 'Still have questions?',
    }
});

export default commonQText;